export const INCREMENT_COUNTER = 'INCREMENT_COUNTER';
